import {
	BusinessMatterClientWithAssociations,
	Matter,
	MatterAdjustmentTarion,
	PersonMatterClientWithAssociations,
} from '@models/matter';
import { Selector } from '@ngxs/store';
import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';
import { MatterClients } from './matter_clients';
import { SelectedMatter } from '@state/matter/matter.selectors';

export interface LLCDataSubmitObjects {
	matter: Matter;
	mortgagors: (
		| PersonMatterClientWithAssociations
		| BusinessMatterClientWithAssociations
	)[];
	guarantors: (
		| PersonMatterClientWithAssociations
		| BusinessMatterClientWithAssociations
	)[];
	tarionWarrantyAdjustment: MatterAdjustmentTarion;
}

export class LLCSelectors {
	@Selector([
		SelectedMatter.getSelected,
		MatterClients.get_mortgagorsWithAssociationMapped,
		MatterClients.get_guarantorsWithAssociationMapped,
		AdjustmentsSelector.tarionWarrantyAdjustment,
	])
	static getSubmitDataObjects(
		matter: Matter,
		mortgagors: (
			| PersonMatterClientWithAssociations
			| BusinessMatterClientWithAssociations
		)[],
		guarantors: (
			| PersonMatterClientWithAssociations
			| BusinessMatterClientWithAssociations
		)[],
		tarionWarrantyAdjustment: MatterAdjustmentTarion,
	): LLCDataSubmitObjects {
		return {
			matter,
			mortgagors,
			guarantors,
			tarionWarrantyAdjustment,
		};
	}
}
